import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { AuthGuard } from '@app/guards/auth.guard';
import { GermanyNotAllowedGuard } from '@app/guards/germany-not-allowed.guard';
import { GrowOnboardingGuard } from '@app/guards/grow-onboarding.guard';
import { GrowUserGuard } from '@app/guards/grow-user.guard';
import { GrowAccountComponent, GrowIntroComponent, GrowRiskComponent } from '@app/modules/grow/components';

const routes: Routes = [
  {
    path: 'grow',
    canActivate: [AuthGuard, GermanyNotAllowedGuard],
    children: [
      { path: '', component: GrowAccountComponent, pathMatch: 'full', canActivate: [GrowUserGuard] },
      { path: 'intro', component: GrowIntroComponent, pathMatch: 'full', canActivate: [GrowOnboardingGuard] },
      { path: 'risk', component: GrowRiskComponent, pathMatch: 'full', canActivate: [GrowOnboardingGuard] }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class GrowRoutingModule {}
